import { render, staticRenderFns } from "./PostLogin.vue?vue&type=template&id=923bb9e0&scoped=true"
import script from "./PostLogin.vue?vue&type=script&lang=js"
export * from "./PostLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923bb9e0",
  null
  
)

export default component.exports